// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__CDWgO","container":"Form_container__H+kjS","field":"Form_field__SOJjy","footer":"Form_footer__Hr17Y"};